<template lang="pug">
  .container-fluid
    .col-md-12
      h1 {{msg}}
</template>

<script>
export default {
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: 'IntriHub'
    }
  },
  ready () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1 {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Index.vue?becae4b6